import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup, Accordion, AccordionItem, Collapse } from "reactstrap";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone, values } from "lodash";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import SimpleBar from "simplebar-react";

// Formik
import { useSelector, useDispatch } from "react-redux";
import { resetDepartmentState, getDepartment } from "../../../store/department/action";
import { getAccAccount, resetAccAccountState } from "../../../store/accAccount/action";
import { getAccAccountClose as onGetAccAccountCloses, addNewAccAccountClose as onAddNewAccAccountClose, updateAccAccountClose as onUpdateAccAccountClose, deleteAccAccountClose as onDeleteAccAccountClose, getAccAccountCloseLoading, resetAccAccountCloseState } from "../../../store/accAccountClose/action";
import { resetAccTransState, getAccTransOne, getAccTrans as onGetAccTranss, addNewAccTrans as onAddNewAccTrans, updateAccTrans as onUpdateAccTrans, deleteAccTrans as onDeleteAccTrans, getAccTransLoading, resetAccTransCreateState } from "../../../store/accTrans/action";
import "react-toastify/dist/ReactToastify.css";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import PrintDoc from "./PrintDoc";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";

import * as Yup from "yup";
import { useFormik } from "formik";
import {
  getAccTag,
  getBudget,
  getCivilBudget,
  getCivilContract,
  getLegal,
  getLegalFraction,
  getLegalMaster,
  getLegalPermission,
  getPaymentMethod,
  getPurchase,
  getSales,
  getTransactionTax,
  getUser,
  resetBudgetState,
  resetCivilBudgetState,
  resetCivilContractState,
  resetLegalFractionState,
  resetLegalMasterState,
  resetLegalPermissionState,
  resetLegalState,
  resetPaymentMethodState,
  resetPurchaseState,
  resetSalesState,
  resetTransactionTaxState,
  resetUserState,
  setClientSelect,
  setCompanySelect,
} from "../../../store/actions";
import CurrencyInput from "react-currency-input-field";
import ModalImage from "react-modal-image";
import { api } from "../../../config";
import ModalInputFile from "../../../Components/ModalInputFile";
import PrintPdf from "./PrintPdf";
import Export from "./Export";

const transTypeData = [
  {
    options: [
      { label: "PENERIMAAN CASH", value: "CASH IN" },
      { label: "PENGELUARAN CASH", value: "CASH OUT" },
      { label: "PIUTANG", value: "RECEIVABLE" },
      { label: "HUTANG", value: "PAYABLE" },
      { label: "LAINNYA", value: "OTHER" },
    ],
  },
];

const AccTrans = () => {
  const printRef = useRef(null);
  const [modal, setModal] = useState(false);
  const [modalClose, setModalClose] = useState(false);
  const [modalBalance, setModalBalance] = useState(false);
  const [modalTrans, setModalTrans] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    clientSelected,
    companySelected,
    branchSelected,
    userData,
    userType,
    userRole,
    accTransOne,
    accTranss,
    loading,
    error,
    companies,
    companyLoading,
    clients,
    clientLoading,
    accAccounts,
    accTransLoading,
    departments,
    departmentLoading,
    branches,
    branchLoading,
    isAccAccountCloseCreated,
    users,
    userLoading,
    budgets,
    budgetLoading,
    legals,
    legalLoading,
    legalMasters,
    legalMasterLoading,
    legalFractions,
    legalFractionLoading,
    legalPermissions,
    legalPermissionLoading,
    civilBudgets,
    civilBudgetLoading,
    civilContracts,
    civilContractLoading,
    purchases,
    purchaseLoading,
    saless,
    salesLoading,
    accTags,
    accTagLoading,
    paymentMethods,
    paymentMethodLoading,
  } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    accTransOne: state.AccTrans.accTransOne,
    accTranss: state.AccTrans.accTranss,
    accTransLoading: state.AccTrans.loading,
    accAccounts: state.AccAccount.accAccounts,
    loading: state.AccAccount.loading,
    error: state.AccAccount.error,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    isAccAccountCloseCreated: state.AccAccountClose.isAccAccountCloseCreated,
    users: state.Users.users,
    userLoading: state.Users.loading,
    budgets: state.Budget.budgets,
    budgetLoading: state.Budget.loading,
    legals: state.Legal.legals,
    legalLoading: state.Legal.loading,
    legalFractions: state.LegalFraction.legalFractions,
    legalFractionLoading: state.LegalFraction.loading,
    legalMasters: state.LegalMaster.legalMasters,
    legalMasterLoading: state.LegalMaster.loading,
    legalPermissions: state.LegalPermission.legalPermissions,
    legalPermissionLoading: state.LegalPermission.loading,
    civilBudgets: state.CivilBudget.civilBudgets,
    civilBudgetLoading: state.CivilBudget.loading,
    civilContracts: state.CivilContract.civilContracts,
    civilContractLoading: state.CivilContract.loading,
    purchases: state.Purchase.purchases,
    purchaseLoading: state.Purchase.loading,
    saless: state.Sales.saless,
    salesLoading: state.Sales.loading,
    accTags: state.AccTag.accTags,
    accTagLoading: state.AccTag.loading,
    paymentMethods: state.PaymentMethod.paymentMethods,
    paymentMethodLoading: state.PaymentMethod.loading,
  }));

  const [departmentSelect, setDepartmentSelect] = useState(null);
  const [branchIdSelected, setBranchIdSelected] = useState(null);
  const [accAccountList, setAccAccountList] = useState([]);
  const [accTransDoc, setAccTransDoc] = useState([]);
  const [info, setInfo] = useState({});
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [accountingList, setAccountingList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [civilContractList, setCivilContractList] = useState([]);
  const [filterAcc, setFilterAcc] = useState();
  const [purchaseList, setPurchaseList] = useState([]);
  const [salesList, setSalesList] = useState([]);
  const [legalList, setLegalList] = useState([]);
  const [legalAssetList, setLegalAssetList] = useState([]);
  const [legalMasterList, setLegalMasterList] = useState([]);
  const [legalPermissionList, setLegalPermissionList] = useState([]);
  const [legalFractionList, setLegalFractionList] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [budgetList, setBudgetList] = useState([]);
  const [civilBudgetDetailList, setCivilBudgetDetailList] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [civilBudgetList, setCivilBudgetList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [docImg, setDocImg] = useState([]);
  const [inputDate, setInputDate] = useState("");
  const [selectTytpe, setSelectTytpe] = useState("");
  const [searchDepartment, setSearchDepartment] = useState("");
  const [accTrans, setAccTrans] = useState(null);
  const [userList, setUserList] = useState([]);

  const [tableItem, setTableItem] = useState([]);

  const [isBudget, setIsBudget] = useState(false);
  const [isLegal, setIsLegal] = useState(false);
  const [isSales, setIsSales] = useState(false);
  const [isPurchase, setIsPurchase] = useState(false);
  const [isCivilContract, setIsCivilContract] = useState(false);
  const [isEditTrans, setIsEditTrans] = useState(false);
  const [accountId, setAccountId] = useState(null);
  const [accountItem, setAccountItem] = useState(null);
  const [accTag, setAccTag] = useState("");

  const validationClose = useFormik({
    enableReinitialize: true,
    initialValues: {
      cclient: clientSelected,
      ccompany: companySelected,
    },
    validationSchema: Yup.object({
      cclient: Yup.object().required("Silahkan isi grup perusahaan"),
      ccompany: Yup.object().required("Please Select Company"),
    }),
    onSubmit: (values) => {
      dispatch(getAccAccountCloseLoading());
      const newAccAccountClose = {
        action: "begining_balance",
        clientId: values.cclient.value,
        companyId: values.ccompany.value,
        data: tableItem,
      };
      dispatch(onAddNewAccAccountClose(newAccAccountClose));

      validationClose.resetForm();
      toggleClose();
      toggleBalance();
    },
  });

  const validationTrans = useFormik({
      enableReinitialize: true,
      initialValues: {
        id: (accTrans && accTrans.id) || 0,
        company: (accTrans && accTrans.company) || companySelected,
        branch: (accTrans && accTrans.branch) || (branchSelected?.value === "all" ? "" : branchSelected),
        client: (accTrans && accTrans.client) || clientSelected,
        approval: (accTrans && accTrans.approval) || false,
        type: accTrans && accTrans.type ? accTrans.type : { label: "HUTANG", value: "PAYABLE" },
        transactionat: (accTrans && accTrans.transactionat) ?? "",
        department: (accTrans && accTrans.department) ?? "",
        paid_amount: (accTrans && accTrans.paid_amount) || 0,
        cvl_budget: (accTrans && accTrans.cvl_budget) ?? "",
        paymentMethod: (accTrans && accTrans.paymentMethod) ?? "",
        tag: (accTrans && accTrans.tag) ?? "",
        sales: (accTrans && accTrans.sales) ?? "",
        purchase: (accTrans && accTrans.purchase) ?? "",
        legal: (accTrans && accTrans.legal) ?? "",
        legal_asset: (accTrans && accTrans.legal_asset) ?? "",
        legal_master: (accTrans && accTrans.legal_master) ?? "",
        legal_permission: (accTrans && accTrans.legal_permission) ?? "",
        legal_fraction: (accTrans && accTrans.legal_fraction) ?? "",
        civilContract: (accTrans && accTrans.civilContract) ?? "",
        amount: (accTrans && accTrans.amount) || 0,
        description: (accTrans && accTrans.description) ?? "",
        user: (accTrans && accTrans.user) ?? "",
        items: (accTrans && accTrans.items) ?? "",
        release: (accTrans && accTrans.release) ?? "",
        budget: (accTrans && accTrans.budget) ?? "",
      },
      validationSchema: Yup.object({
        transactionat: Yup.string().required("Please Pick Transaction Date"),
        amount: Yup.string().required("Silahkan isi Jumlah Transaksi"),
        type: Yup.object().required("Please Select Warehouse").nullable(true),
        company: Yup.object().required("Please Select company").nullable(true),
        client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
        branch: Yup.object().required("Silahkan isi Proyek / Cabang").nullable(true),
        //department: Yup.object().required("Silahkan isi Department").nullable(true),
      }),
      onSubmit: (values) => {
        if (isEditTrans) {
          let editSubmit = {
            id: values.id,
            statusId: accTrans?.statusId,
            accTransPaymentId: accTrans.accTransPaymentId,
            userId: values.user.value,
            type: values.type.value,
            transactionat: values.transactionat,
            paymentMethodId: values.paymentMethod.value,
            description: values.description,
            clientId: values.client.value,
            budgetId: values.budget.value,
            tagId: values.tag.value,
            companyId: values.company.value,
            departmentId: values.department.value,
            branchId: values.branch.value,
            salesId: values.sales.value,
            legalId: values.legal.type === "inventory" ? values.legal.value : values.legal_asset.value,
            legalMasterId: values.legal_master.value,
            legalPermissionId: values.legal_permission.value,
            legalFractionalId: values.legal_fraction.value,
            civilContractId: values.civilContract.value,
            purchaseId: values.purchase.value,
            civilAccountId: values.cvl_budget.civilAccountId || null,
            civilBudgetId: values.cvl_budget.civilBudgetId || null,
            civilBudgetDetailId: values.cvl_budget.civilBudgetDetailId || null,
            amount: values.amount,
            paid_amount: values.paid_amount,
            at_detail: JSON.stringify(values.items),
            at_rls: JSON.stringify(values.release),
            files: docImg.length > 0 ? docImg : [],
          };
          dispatch(onUpdateAccTrans(editSubmit));
        } else {
          let addSubmit = {
            accTransPaymentId: accTrans?.accTransPaymentId,
            userId: values.user.value,
            type: values.type.value,
            transactionat: values.transactionat,
            paymentMethodId: values.paymentMethod.value,
            description: values.description,
            clientId: values.client.value,
            budgetId: values.budget.value,
            tagId: values.tag.value,
            companyId: values.company.value,
            departmentId: values.department.value,
            branchId: values.branch.value,
            salesId: values.sales.value,
            purchaseId: values.purchase.value,
            legalId: values.legal.type === "inventory" ? values.legal.value : values.legal_asset.value,
            legalMasterId: values.legal_master.value,
            legalPermissionId: values.legal_permission.value,
            legalFractionalId: values.legal_fraction.value,
            civilContractId: values.civilContract.value,
            civilAccountId: values.cvl_budget.civilAccountId || null,
            civilBudgetId: values.cvl_budget.civilBudgetId || null,
            civilBudgetDetailId: values.cvl_budget.civilBudgetDetailId || null,
            amount: values.amount,
            paid_amount: values.paid_amount,
            at_detail: JSON.stringify(values.items),
            at_rls: JSON.stringify(values.release),
            files: docImg.length > 0 ? docImg : [],
          };
          dispatch(onAddNewAccTrans(addSubmit));
        }
        validationTrans.resetForm();
        toggle();
      },
    });


  useEffect(() => {
    if (branchSelected) {
      setDepartmentSelect({ label: userData?.user?.user_department?.name, value: userData?.user?.user_department?.id });
      handleGetAccAccount(companySelected.value, branchSelected.value);
      handleGetBudget(companySelected?.value, branchSelected?.value);
      handleGetDepartement(companySelected.value);
    }
  }, [branchSelected]);

  const handleGetSales = (companyId, branchId) => {
    dispatch(resetSalesState());
    dispatch(getSales({ companyId: companyId, branchId: branchId, simple: "true", date: "all" }));
  };

  const handleGetPurchase = (companyId, branchId) => {
    dispatch(resetPurchaseState());
    dispatch(getPurchase({ companyId: companyId, branchId: branchId, date: "all" }));
  };

  const handleGetCivilContract = (companyId, branchId) => {
    dispatch(resetCivilContractState());
    dispatch(getCivilContract({ companyId: companyId, branchId: branchId }));
  };

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, branchId: branchId, simple: true }));
  };

  const handleGetAccTrans = (get, id, type = null) => {
    if (get === "one") {
      dispatch(getAccTransOne(id));
      if (type === "edit") {
        setIsEditTrans(true);
      }
    }
    if (get === "all") {
      dispatch(resetAccTransState());
      let startat = "";
      let endat = "";
      let datearr = filterDate?.split(" to ");
      if (datearr) {
        startat = datearr[0];
        endat = datearr[1] ? datearr[1] : datearr[0];
      }
      const params = {
        // startat: startat,
        // endat: endat,
        companyId: companySelected?.value,
        accId: id,
      };
      dispatch(onGetAccTranss(params));
      setAccountId(id);
    }
  };

  const handleGetDepartement = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  const handleGetAccAccount = (companyId, branchId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, branchId: branchId, status: 2, ledger: true }));
    handleGetUser(companyId);
    handleGetTag(companyId);
    handleGetTransactionTax(companyId);
    handleGetPaymentMethod(companyId, branchId);
  };

  const handleGetUser = (companyId) => {
    dispatch(resetUserState());
    dispatch(getUser({ status: 2 }));
  };

  const handleGetTag = (companyId) => {
    dispatch(getAccTag({ companyId: companyId }));
  };

  const handleGetPaymentMethod = (id, branchId) => {
    dispatch(resetPaymentMethodState());
    dispatch(getPaymentMethod({ companyId: id, branchId: branchId, status: 2, type: "all" }));
  };

  const handleGetTransactionTax = (companyId) => {
    dispatch(resetTransactionTaxState());
    dispatch(getTransactionTax({ companyId: companyId, status: 2 }));
  };

  const handleGetCivilBudget = (companyId, branchId) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: companyId, branchId: branchId }));
  };

  const handleGetLegal = (companyId) => {
    dispatch(resetLegalState());
    dispatch(getLegal({ companyId: companyId, status: 2 }));
  };

  const handleGetLegalMaster = (companyId, branchId) => {
    dispatch(resetLegalMasterState());
    dispatch(getLegalMaster({ companyId: companyId, branchId: branchId, status: 2 }));
  };

  const handleGetLegalPermisson = (companyId, branchId) => {
    dispatch(resetLegalPermissionState());
    dispatch(getLegalPermission({ companyId: companyId, branchId: branchId, status: 2 }));
  };

  const handleGetLegalFraction = (companyId, branchId) => {
    dispatch(resetLegalFractionState());
    dispatch(getLegalFraction({ companyId: companyId, branchId: branchId, status: 2 }));
  };

  const handleAccTransDetailAdd = (condition) => {
    let obj = {
      itemId: 0,
      isPrimary: false,
      description: "",
      sort_order: validationTrans.values.items.length + 1,
      debit: 0,
      credit: 0,
      accId: "",
      acc: "",
    };

    if (condition === "double") {
      validationTrans.setFieldValue("items", [
        obj,
        {
          itemId: 1,
          isPrimary: false,
          description: "",
          sort_order: validationTrans.values.items.length + 1,
          debit: 0,
          credit: 0,
          accId: "",
          acc: "",
        },
      ]);
    } else validationTrans.setFieldValue("items", [...validationTrans.values.items, obj]);
  };

  const onClickDeleteDetailItem = (index) => {
    validationTrans.values.items.splice(index, 1);
    validationTrans.setFieldValue("items", validationTrans.values.items);
  };

  const handleDeleteFile = (file) => {
    const newState = docImg.map((obj) => {
      if (obj.filename === file.filename) {
        return { filename: file.filename, isDeleted: true };
      }
      return obj;
    });
    setDocImg(newState);
  };
  const handleSelectFile = (file) => {
    setDocImg((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  const handleItem = () => {
    //  name: data.name,
    //         code: data.code,
    //         type: data.type,
    //         accId: data.accId,
    //         closeat: data.closeat,
    //         month_no: data.month_no,
    //         year_no: data.year_no,
    //         debit: data.debit,
    //         credit: data.credit,
    //         description: data.description,
    //         createdby: req.userId,
    //         createdat: moment().format('YYYY/MM/DD HH:mm:ss')
    let fc = [];
    let debitValue = 0;
    let creditValue = 0;

    accAccountList.forEach((acc) => {
      if (!acc.acc_account_close?.[0]?.closeat) {
        debitValue = 0;
        creditValue = 0;
      } else {
        debitValue = acc.acc_account_close?.[0]?.debit;
        creditValue = acc.acc_account_close?.[0]?.credit;
      }

      const str = inputDate;
      const [yearNo, monthNo] = str.split("/");
      const monthNoParse = parseInt(monthNo, 10);

      const type = selectTytpe?.value ?? "";

      fc.push({
        code: acc.code,
        name: acc.name,
        categoryId: acc.categoryId || null,
        accId: acc.id,
        default: acc?.acc_account_category?.type || null,
        isBegining: true,
        closeat: acc.closeat || inputDate,
        status: "1",
        type: acc.type || type,
        month_no: monthNoParse,
        year_no: yearNo,
        debit: acc.headerSaldo >= 0 ? acc.headerSaldo : 0,
        credit: acc.headerSaldo < 0 ? acc.headerSaldo : 0,
        description: "",
      });
    });
    setTableItem(fc);
  };

  useEffect(() => {
    if (accTransOne) setInfo(accTransOne);
  }, [accTransOne]);

  useEffect(() => {
    if (!isEmpty(civilBudgets)) {
      var civilBudgetData = [];
      var civilBudgetDetailData = [];
      var opt = [];
      var opt_detail = [];
      civilBudgets.forEach((it, idx) => {
        if (branchIdSelected === it.branchId) {
          const title = it.name ? it.name : "";
          const type = it.type ? it.type : "";
          const budgetId = it.id ? it.id : "";
          it.cvl_detail.forEach((item, key) => {
            if (type === "INFRASTRUKTUR" || type === "BANGUNAN" || type === "PEKERJAAN TAMBAH 1" || type === "PEKERJAAN TAMBAH 2" || type === "PEKERJAAN TAMBAH 3" || type === "PEKERJAAN TAMBAH 4" || type === "PEKERJAAN TAMBAH 5" || type === "PEKERJAAN TAMBAH 6" || type === "PEKERJAAN TAMBAH 7" || type === "PEKERJAAN TAMBAH 8" || type === "LISTRIK JARINGAN") {
              const name = item.cvld_account ? type + " - " + item.cvld_account.name : "";
              const id = item.cvld_account ? item.cvld_account.id : "";
              opt_detail.push({ label: name, value: id, civilBudgetDetailId: item.id, civilBudgetId: budgetId, civilAccountId: id });
            }
          });
          opt.push({ label: title, value: budgetId, type: type });
        }
      });
      var option_detail = { options: opt_detail.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      civilBudgetDetailData.push(option_detail);
      setCivilBudgetDetailList(civilBudgetDetailData);

      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      civilBudgetData.push(option);
      setCivilBudgetList(civilBudgetData);
    } else {
      setCivilBudgetDetailList([]);
      setCivilBudgetList([]);
    }
  }, [civilBudgets, branchIdSelected]);

  useEffect(() => {
    if (!isEmpty(budgets)) {
      var data = [];
      var opt = [{ label: "", value: "" }];
      budgets.forEach((item, key) => {
        const name = item.type + " - " + item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setBudgetList(data);
    } else {
      setBudgetList([]);
    }
  }, [budgets]);

  useEffect(() => {
    if (!isEmpty(paymentMethods)) {
      var data = [];
      var opt = [];
      paymentMethods.forEach((item, key) => {
        const name = item.name;
        const label = item?.pm_branch?.branch_code ? name + " - " + item?.pm_branch?.branch_code : name;
        const id = item.id;
        var obj = { label: label, value: id, sort_order: item?.sort_order + "-", item: item, tag: { label: item?.pm_tag?.name, value: item.tagId } };
        if (accTag) {
          if (item.tagId && accTag === item.tagId)
            opt.push(obj);
        }
        else
          opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => a.sort_order.localeCompare(b.sort_order, undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setPaymentMethodList(data);
    } else {
      setPaymentMethodList([]);
    }
  }, [paymentMethods, accTag]);

  useEffect(() => {
    if (!isEmpty(civilContracts)) {
      var data = [];
      var opt = [];
      civilContracts.forEach((item, key) => {
        const transaction_no = item.transaction_no;
        const transactionat = item.transactionat;
        const customer = item.cvl_contract_vendor ? item.cvl_contract_vendor.name : "";
        const id = item.id;
        var obj = { label: transaction_no + " - " + customer + " / " + currencyFormat(item.amount) + " - " + handleValidDate(transactionat), value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setCivilContractList(data);
    }
  }, [civilContracts]);

  useEffect(() => {
    if (!isEmpty(accTags)) {
      var data = [];
      var opt = [];
      accTags.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setTagList(data);
    }
  }, [accTags]);

  useEffect(() => {
    if (!isEmpty(purchases)) {
      var data = [];
      var opt = [];
      purchases.forEach((item, key) => {
        const transaction_no = item.transaction_no;
        const transactionat = item.transactionat;
        const customer = item.purchase_vendor ? item.purchase_vendor.name : "";
        const id = item.id;
        var obj = { label: transaction_no + " - " + customer + " / " + currencyFormat(item.total_amount) + " - " + handleValidDate(transactionat), value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setPurchaseList(data);
    }
  }, [purchases]);

  useEffect(() => {
    if (!isEmpty(legals)) {
      var data = [];
      var opt = [];
      var data_asset = [];
      var opt_asset = [];
      legals.forEach((item, key) => {
        const name = item.name;
        const code = item.code ? item.code + " : " + name + ", " : "";
        const quantity = item.quantity;
        const owner = item.owner;
        const nominatif = item.nominatif;
        const id = item.id;
        var obj = { label: code + owner + " - " + parseFloat(quantity) + " M²", value: id, type: item.type };
        if (item.type === "inventory") opt.push(obj);

        var obj_asset = { label: nominatif + " - " + parseFloat(quantity) + " M²", value: id, type: item.type };
        if (item.type === "asset") opt_asset.push(obj_asset);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setLegalList(data);

      var option_asset = { options: opt_asset.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data_asset.push(option_asset);
      setLegalAssetList(data_asset);
    }
  }, [legals]);

  useEffect(() => {
    if (!isEmpty(legalMasters)) {
      var data = [];
      var opt = [];
      legalMasters.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setLegalMasterList(data);
    }
  }, [legalMasters]);

  useEffect(() => {
    if (!isEmpty(legalFractions)) {
      var data = [];
      var opt = [];
      legalFractions.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setLegalFractionList(data);
    }
  }, [legalFractions]);

  useEffect(() => {
    if (!isEmpty(legalPermissions)) {
      var data = [];
      var opt = [];
      legalPermissions.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: item?.legal_per_document?.name + " - " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setLegalPermissionList(data);
    }
  }, [legalPermissions]);

  useEffect(() => {
    setAccAccountList(
      (accAccounts || []).map((el) => {
        let temp_saldo = 0;
        let temp_saldo_close = 0;
        const debit = el.acc_account_trans_detail && el.acc_account_trans_detail.reduce((a, v) => (a = a + parseFloat(v.debit || 0)), 0);
        const credit = el.acc_account_trans_detail && el.acc_account_trans_detail.reduce((a, v) => (a = a + parseFloat(v.credit || 0)), 0);
        let valAccClose = "";
        if (Array.isArray(el.acc_account_close) && el.acc_account_close.length > 0) {
          valAccClose = el.acc_account_close[el.acc_account_close.length - 1];
        }

        let debitClose = valAccClose.debit ? parseFloat(valAccClose.debit) : 0;
        let creditClose = valAccClose.credit ? parseFloat(valAccClose.credit) : 0;
        if (debitClose > 0) {
          temp_saldo_close = parseFloat(temp_saldo_close) + parseFloat(debitClose);
        }
        if (creditClose > 0) {
          temp_saldo_close = parseFloat(temp_saldo_close) - parseFloat(creditClose);
        }

        temp_saldo = temp_saldo_close;
        let headerSaldo = temp_saldo;
        for (const element of el.acc_account_trans_detail || []) {
          let headerDebit = element.debit ? parseFloat(element.debit) : 0;
          let headerCredit = element.credit ? parseFloat(element.credit) : 0;
          if (headerDebit > 0) {
            headerSaldo = parseFloat(headerSaldo) + parseFloat(headerDebit);
          }
          if (headerCredit > 0) {
            headerSaldo = parseFloat(headerSaldo) - parseFloat(headerCredit);
          }
        }
        return { ...el, isChecked: false, headerSaldo };
      }),
    );
  }, [accAccounts]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "code",
        label: "Nama Akun",
        isSelected: true,
        data: [],
      },
      {
        id: "def",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
      {
        id: "debit",
        label: "Debit",
        isSelected: true,
        data: [],
      },
      {
        id: "credit",
        label: "Kredit",
        isSelected: true,
        data: [],
      },
      {
        id: "saldo",
        label: "Saldo",
        isSelected: true,
        data: [],
      },
      ///
      {
        id: "tgl",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "no",
        label: "Nomor",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Type",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];
    if (accAccountList.length > 0) {
      accAccountList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);

            if (doc) {
              if (doc.id === "code") {
                doc.data.push(`${value} ${data.name}`);
              }
            } else {
              if (key === "acc_account_category") {
                const code = dataDoc.find((d) => d.id === "code");
                const debit = dataDoc.find((d) => d.id === "debit");
                const credit = dataDoc.find((d) => d.id === "credit");
                const def = dataDoc.find((d) => d.id === "def");
                const saldo = dataDoc.find((d) => d.id === "saldo");

                const valDebit = data.acc_account_trans_detail?.reduce((a, v) => a + parseFloat(v.debit || 0), 0) || 0;
                const valCredit = data.acc_account_trans_detail?.reduce((a, v) => a + parseFloat(v.credit || 0), 0) || 0;

                const valdef = data?.acc_account_category?.type;

                const diff = valDebit - valCredit;

                const valSaldo = data?.acc_account_category?.type === "DEBIT" && diff < 0 ? `( ${currencyFormat(Math.abs(diff))} )` : data?.acc_account_category?.type === "CREDIT" && diff > 0 ? `( ${currencyFormat(Math.abs(diff))} )` : currencyFormat(Math.abs(diff));

                debit.data.push(data.headerSaldo >= 0 ? data.headerSaldo : 0);
                credit.data.push(data.headerSaldo < 0 ? data.headerSaldo : 0);
                def.data.push(valdef);
                saldo.data.push(data.headerSaldo);

                ////

                const trans = data?.acc_account_trans_detail;
                const tglDetail = dataDoc.find((d) => d.id === "tgl");
                const noDetail = dataDoc.find((d) => d.id === "no");
                const typeDetail = dataDoc.find((d) => d.id === "type");
                const descriptionDetail = dataDoc.find((d) => d.id === "description");

                tglDetail.data.push("");
                noDetail.data.push("");
                typeDetail.data.push("");
                descriptionDetail.data.push("");

                if (Array.isArray(trans) && trans.length > 0) {
                  const sortedTrans = [...trans].sort((a, b) => {
                    return new Date(a?.at_detail_trans?.transactionat).getTime() - new Date(b?.at_detail_trans?.transactionat).getTime() || a?.at_detail_trans?.code - b?.at_detail_trans?.code;
                  });
                  let temp_saldo = 0;
                  let temp_saldo_close = 0;

                  let valAccClose = "";
                  if (Array.isArray(data.acc_account_close) && data.acc_account_close.length > 0) {
                    valAccClose = data.acc_account_close[data.acc_account_close.length - 1];
                  }

                  let debitClose = valAccClose.debit ? parseFloat(valAccClose.debit) : 0;
                  let creditClose = valAccClose.credit ? parseFloat(valAccClose.credit) : 0;
                  if (debitClose > 0) {
                    temp_saldo_close = parseFloat(temp_saldo_close) + parseFloat(debitClose);
                  }
                  if (creditClose > 0) {
                    temp_saldo_close = parseFloat(temp_saldo_close) - parseFloat(creditClose);
                  }

                  temp_saldo = temp_saldo_close;

                  if (sortedTrans.length > 1) {
                    for (let i = 0; i < sortedTrans.length; i++) {
                      const valType = trans?.[i]?.at_detail_trans?.type;
                      const debitDetail = trans?.[i]?.debit ? parseFloat(trans?.[i]?.debit) : 0;
                      const creditDetail = trans?.[i]?.credit ? parseFloat(trans?.[i]?.credit) : 0;

                      if (debitDetail > 0) {
                        temp_saldo = parseFloat(temp_saldo) + parseFloat(debitDetail);
                      }
                      if (creditDetail > 0) {
                        temp_saldo = parseFloat(temp_saldo) - parseFloat(creditDetail);
                      }

                      debit.data.push(trans?.[i] ? currencyFormat(trans?.[i]?.debit) : 0);
                      credit.data.push(trans?.[i] ? currencyFormat(trans?.[i]?.credit) : 0);
                      saldo.data.push(data?.type === "DEBIT" && temp_saldo < 0 ? currencyFormat(temp_saldo) : data?.type === "CREDIT" && temp_saldo > 0 ? currencyFormat(temp_saldo) : currencyFormat(temp_saldo));

                      code.data.push("");
                      def.data.push("");
                      tglDetail.data.push(handleValidDate(trans?.[i]?.at_detail_trans?.transactionat, "DD/MM/YYYY") ?? "");
                      noDetail.data.push(trans?.[i]?.at_detail_trans?.transaction_no ?? "");
                      typeDetail.data.push(valType ?? "");
                      descriptionDetail.data.push(trans?.[i]?.at_detail_trans?.description ?? "");
                    }
                  }
                }
              }
            }
          });
        }
      });
    }

    setAccTransDoc(dataDoc);
  }, [accAccountList]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        const categoryCode = item.category_code;
        var obj = { label: code + " " + name, value: id, category: categoryCode };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      var departmentData = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      departmentData.push(option);
      setDepartmentList(departmentData);
    }
  }, [departments]);

  const transScrollRef = useRef(null);

  const toggleActiveAccordion = (el) => {
    if (el !== activeAccordion) setActiveAccordion(el);
    else setActiveAccordion(null);
  };

  // setiap baris akun yang dibuka mulai dari atas, bukan sisa scroll baris sebelumnya
  useEffect(() => {
    if (transScrollRef.current) transScrollRef.current.scrollTop = 0;
  }, [activeAccordion]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setInfo({});
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleTrans = useCallback(() => {
    if (modalTrans) {
      setModalTrans(false);
      setAccTrans(null);
      setDocImg([]);
      setIsEditTrans(false);
      validationTrans.resetForm();
    } else {
      setModalTrans(true);
    }
  }, [modalTrans]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleClose = useCallback(() => {
    if (modalClose) {
      setModalClose(false);
    } else {
      setModalClose(true);
    }
  }, [modalClose]);

  const toggleBalance = useCallback(() => {
    if (modalBalance) {
      setModalBalance(false);
      setSearchValueModal("");
      setInputDate("");
      setSelectTytpe("");
    } else {
      setModalBalance(true);
    }
  }, [modalBalance]);

  const handleAccTransClick = useCallback(
    (arg, type) => {
      const data = arg;
      let accTransDetail = [];
      if (data.at_detail) {
        for (const element of data.at_detail) {
          accTransDetail.push({
            itemId: element.id,
            description: element.description,
            sort_order: parseInt(element.sort_order),
            debit: parseFloat(element.debit || 0),
            credit: parseFloat(element.credit || 0),
            accId: element.accId,
            acc: { label: element.at_detail_account && element.at_detail_account.name, value: element.at_detail_account && element.at_detail_account.id },
            isPrimary: element.isPrimary,
          });
        }
      }

      let files = [];
      if (data.at_file && data.at_file.length > 0) {
        data.at_file.forEach((element) => {
          files.push({
            filename: element.filename,
            originalname: element.originalname,
          });
        });
      }
      if (files.length > 0) setDocImg(files);
      setBranchIdSelected(data.branchId);
      handleGetCivilBudget(data.companyId, data.branchId);

      let transType;
      switch (data.type) {
        case "CASH IN":
          transType = { label: "PENERIMAAN CASH", value: "CASH IN" };
          break;
        case "CASH OUT":
          transType = { label: "PENGELUARAN CASH", value: "CASH OUT" };
          break;
        case "RECEIVABLE":
          transType = { label: "PIUTANG", value: "RECEIVABLE" };
          break;
        case "PAYABLE":
          transType = { label: "HUTANG", value: "PAYABLE" };
          break;
        default:
          transType = { label: "OTHER", value: "OTHER" };
          break;
      }

      setIsBudget(false);
      if (data.civilAccountId || data.civilBudgetId) {
        setIsBudget(true);
      }

      setIsSales(false);
      if (data.salesId) {
        setIsSales(true);
        handleGetSales(data.companyId, data.branchId);
      }

      setIsPurchase(false);
      if (data.purchaseId) {
        setIsPurchase(true);
        handleGetPurchase(data.companyId, data.branchId);
      }

      setIsCivilContract(false);
      if (data.civilContractId) {
        setIsCivilContract(true);
        handleGetCivilContract(data.companyId, data.branchId);
      }

      setIsLegal(false);
      if (data.legalId || data.legalMasterId || data.legalPermissionId || data.legalFractionalId) {
        setIsLegal(true);
        handleGetLegal(data.companyId);
        handleGetLegalFraction(data.companyId, data.branchId);
        handleGetLegalMaster(data.companyId, data.branchId);
        handleGetLegalPermisson(data.companyId, data.branchId);
      }

      setAccTrans({
        id: data.id,
        accTransPaymentId: type === "payment" ? data.id : data.accTransPaymentId,
        statusId: data.statusId,
        companyId: data.companyId,
        branchId: data.branchId,
        approval: data.approval,
        departmentId: data.departmentId,
        cvl_budget: data.at_cvl_budget && {
          label: data.at_cvl_account ? data.at_cvl_account.name : "",
          value: data.at_cvl_account ? data.at_cvl_account.id : "",
          civilAccountId: data.at_cvl_account ? data.at_cvl_account.id : "",
          civilBudgetDetailId: data.at_cvl_budget.id,
          civilBudgetId: data.civilBudgetId,
        },
        description: data.description,
        code: data.code,
        transaction_no: data.transaction_no,
        transactionat: data.transactionat,
        paid_amount: data.paid_amount,
        amount: parseFloat(data.amount),
        type: type === "payment" ? { label: "PENGELUARAN CASH", value: "CASH OUT" } : transType,
        paymentMethod: data.at_pm && {
          label: data.at_pm.name,
          value: data.at_pm.id,
        },
        at_department: data.at_department,
        at_branch: data.at_branch,
        at_cvl_budget: data.at_cvl_budget,
        civilContract: data.at_cvl_contract && { label: data.at_cvl_contract.transaction_no, value: data.at_cvl_contract.id },
        sales: data.at_sales && { label: data.at_sales.transaction_no, value: data.at_sales.id },
        purchase: data.at_purchase && { label: data.at_purchase.transaction_no, value: data.at_purchase.id },
        legal: data.at_legal?.type === "inventory" && data.at_legal && { label: data.at_legal.name + ", " + data.at_legal.owner + " - " + parseFloat(data.at_legal.quantity) + " M²", value: data.at_legal.id, type: data.at_legal.type },
        legal_asset: data.at_legal?.type === "asset" && data.at_legal && { label: data.at_legal.nominatif + " - " + parseFloat(data.at_legal.quantity) + " M²", value: data.at_legal.id, type: data.at_legal.type },
        legal_master: data.at_legal_mst && { label: data.at_legal_mst.name, value: data.at_legal_mst.id },
        legal_fraction: data.at_legal_fractional && { label: data.at_legal_fractional.name, value: data.at_legal_fractional.id },
        legal_permission: data.at_legal_per && { label: data?.at_legal_per?.legal_per_document?.name + "-" + data.at_legal_per.name, value: data.at_legal_per.id },
        department: data.at_department && { label: data.at_department.name, value: data.at_department.id },
        tag: data.at_tag && { label: data.at_tag.name, value: data.at_tag.id },
        branch: data.at_branch && { label: data.at_branch.name, value: data.at_branch.id },
        company: data.at_company && { label: data.at_company.name, value: data.at_company.id },
        client: data.at_client && { label: data.at_client.name, value: data.at_client.id },
        budget: data.at_budget && { label: data.at_budget.name, value: data.at_budget.id },
        user: data.at_user && {
          label: data.at_user.name,
          value: data.at_user.id,
        },
        items: accTransDetail,
        release: data.at_rls ? data.at_rls : [],
      });

      toggleTrans();
    },
    [toggleTrans, userType],
  );

  useEffect(() => {
    if (isEditTrans && accTransOne !== undefined) {
      handleAccTransClick(accTransOne);
    }
  }, [accTransOne, isEditTrans]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const [searchValue, setSearchValue] = useState("");

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      departmentId: searchDepartment.value ?? "",
      companyId: companySelected?.value,
      accId: filterAcc?.value ?? "",
      ledger: true,
    };

    setActiveAccordion(null);
    dispatch(getAccAccount(param));
  }

  function handleResetFilter() {
    setFilterDate(null);
    setSearchValue("");
    setSearchDepartment("");
    setFilterAcc("");
    handleGetAccAccount(companySelected?.value, branchSelected?.value);
  }

  useEffect(() => {
    if (!isEmpty(users)) {
      var userData = [];
      var opt = [];
      users.forEach((item, key) => {
        const name = item.name;
        const company = item?.user_company?.name;
        const type = item.userType === "user" || item.userType === "holding" || item.userType === "admin" || item.userType === "client" || item.userType === "company" ? "Karyawan" : item.userType === "vendor" ? "Supplier" : item.userType === "agent" ? "Salesman" : "Konsumen";
        const id = item.id;
        var obj = { label: name + ",  " + company + " (" + type + ")", value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      userData.push(option);
    }
    setUserList(userData);
  }, [users]);

  const [isCheckAll, setIsCheckAll] = useState(false);
  const checkedAll = () => {
    const nextCheckAll = !isCheckAll;

    const updated = accAccountList.map((item) => ({
      ...item,
      isChecked: nextCheckAll,
    }));

    setAccAccountList(updated);
    setIsCheckAll(nextCheckAll);
  };

  useEffect(() => {
    if (accAccountList.length === 0) {
      setIsCheckAll(false);
      return;
    }

    const allChecked = accAccountList.every((item) => item.isChecked === true);

    setIsCheckAll(allChecked);
  }, [accAccountList]);

  useEffect(() => {
    handleGetAccAccount(companySelected.value);
  }, [isAccAccountCloseCreated]);

  const [searchValueModal, setSearchValueModal] = useState("");
  const filteredItems = tableItem.filter((item) => {
    const search = searchValueModal.toLowerCase();
    return item.code?.toLowerCase().includes(search) || item.name?.toLowerCase().includes(search);
  });

  function isDateBetween(dateToCheckString, startDateString, endDateString) {
    const dateToCheck = new Date(dateToCheckString);
    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);

    if (isNaN(dateToCheck.getTime()) || isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      console.error("Invalid date format provided.");
      return false;
    }

    return dateToCheck >= startDate && dateToCheck <= endDate;
  }

  // filter frontend: langsung berlaku saat input filter berubah, tanpa fetch ulang ke backend
  const filteredAccountList = useMemo(() => {
    let data = accAccountList || [];

    const search = (searchValue || "").trim().toLowerCase();
    if (search) {
      data = data.filter((el) => (el.code || "").toLowerCase().includes(search) || (el.name || "").toLowerCase().includes(search));
    }

    if (filterAcc?.value !== undefined && filterAcc?.value !== null && filterAcc?.value !== "") {
      data = data.filter((el) => el.id === filterAcc.value);
    }

    if (searchDepartment?.value !== undefined && searchDepartment?.value !== null && searchDepartment?.value !== "") {
      data = data.filter((el) => (el.trans || []).some((t) => t.departmentId === searchDepartment.value));
    }

    const datearr = filterDate?.split(" to ");
    if (datearr && datearr[0]) {
      const startat = datearr[0];
      const endat = datearr[1] ? datearr[1] : datearr[0];
      data = data.filter((el) => (el.trans || []).some((t) => isDateBetween(handleValidDate(t?.transactionat, "YYYY/MM/DD"), startat, endat)));
    }

    return data;
  }, [accAccountList, searchValue, filterAcc, searchDepartment, filterDate]);

  function debitCreditClass(type, categoryId, balance) {
    return type === "DEBIT" && balance > 0 ? "text-end text-success" : type === "CREDIT" && (categoryId === 12 || categoryId === 15) && balance < 0 ? "text-end text-success" : "text-end text-danger";
  }

  function debitCreditBalanceValue(type, categoryId, balance) {
    return type === "DEBIT" && balance > 0 ? currencyFormat(Math.abs(balance)) : balance === 0 ? 0 : type === "CREDIT" && (categoryId === 12 || categoryId === 15) && balance < 0 ? currencyFormat(Math.abs(balance)) : `( ${currencyFormat(Math.abs(balance))} )`

  }

  document.title = "Buku Besar | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={accAccountList} />
      <Container fluid>
        <BreadCrumb title="Keuangan" pageTitle="BUKU BESAR" loading={loading || accTransLoading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className="btn btn-info add-btn me-2"
              id="create-btn"
              onClick={() => {
                toggleTrans();
                handleAccTransDetailAdd("double");
              }}
            >
              <i className="ri-add-line me-1 align-bottom fs-14"></i> Jurnal Umum
            </button>
            <button
              type="button"
              className="btn btn-warning add-btn me-2"
              id="create-btn"
              onClick={() => {
                toggleClose();
                setActiveAccordion(null);
                toggleActiveAccordion(null);
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tutup Buku
            </button>
            {/* <ExportDoc className="me-2" data={accTransDoc} /> */}
            {/* <PrintPdf /> */}
            <Export data={accAccountList} />
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody className="pt-1">
                <div>
                  <Row>
                    <CardBody className="pb-0">
                      <Row>
                        <Col sm={3}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                              }}
                              placeholder={`Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <Select
                            name="searchAcc"
                            isClearable
                            value={filterAcc}
                            placeholder="Filter Akun"
                            onChange={(e) => {
                              setFilterAcc(e);
                            }}
                            options={accountingList}
                          ></Select>
                        </Col>
                        <Col sm={2}>
                          <Select
                            isClearable
                            name="searchDepartment"
                            value={searchDepartment}
                            placeholder="Filter Department"
                            onChange={(e) => {
                              setSearchDepartment(e);
                            }}
                            options={departmentList}
                          ></Select>
                        </Col>
                        <Col sm={2}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              value={filterDate}
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            <i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100 fw-semibold"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="hstack text-muted border-bottom border-top" style={{ width: "100%" }}>
                    <div className="d-flex align-items-center" style={{ width: "30%" }}>
                      <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />
                      <div className="p-2">Nama Akun / Tanggal</div>
                    </div>
                    <div className="" style={{ width: "34%" }}>
                      <div className="p-2">Keterangan</div>
                    </div>
                    <div className="text-end" style={{ width: "12%" }}>
                      <div className="p-2">Debit</div>
                    </div>
                    <div className="text-end" style={{ width: "12%" }}>
                      <div className="p-2">Kredit</div>
                    </div>
                    <div className="text-end" style={{ width: "12%" }}>
                      <div className="p-2">Saldo</div>
                    </div>
                  </div>
                  {filteredAccountList.map((el, idx) => {
                    let temp_saldo = el.close_balance;
                    let def;
                    switch (el.type) {
                      case "CREDIT":
                        def = <span className="badge text-uppercase badge-soft-warning"> {el.type} </span>;
                        break;
                      case "DEBIT":
                        def = <span className="badge text-uppercase badge-soft-success"> {el.type} </span>;
                        break;
                      default:
                        def = <span className="badge text-uppercase badge-soft-warning"> {el.type} </span>;
                        break;
                    }

                    let startat = "";
                    let endat = "";
                    let datearr = filterDate?.split(" to ");
                    if (datearr) {
                      startat = datearr[0];
                      endat = datearr[1] ? datearr[1] : datearr[0];
                    }
                    return (
                      <div key={idx} className="d-flex align-items-start">
                        <input
                          type="checkbox"
                          style={{
                            marginTop: "10px",
                          }}
                          className="dataCheckbox me-2 form-check-input"
                          checked={el.isChecked}
                          onChange={() => {
                            const updatedData = accAccountList.map((d) => (d.id === el.id ? { ...d, isChecked: !d.isChecked } : d));
                            setAccAccountList(updatedData);
                          }}
                        />
                        <Accordion style={{ flex: "1" }} toggle={toggleActiveAccordion} open={['false']} className="p-0 border-0 lefticon-accordion accordion-primary custom-accordionwithicon">
                          <AccordionItem className="border-0">
                            <div
                              className={classnames("accordion-button p-0 m-0 ps-4 fs-13 border-bottom", { collapsed: activeAccordion === el.id ? false : true })}
                              onClick={() => {
                                toggleActiveAccordion(el.id);
                                //handleGetAccTrans("all", el.id, "");
                                setAccountItem(el);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="hstack pb-1 fs-14" style={{ width: "100%" }}>
                                <div className="" style={{ width: "40%" }}>
                                  <div className="p-2">
                                    <Link className="text-primary" to={`/ledger-detail/${el.id}`} target="_blank">
                                      ({el.code}) {el.name}
                                    </Link>
                                  </div>
                                </div>
                                <div className="text-end" style={{ width: "21%" }}>
                                  <div className="p-2 ps-0">{def}</div>
                                </div>
                                <div className="text-end" style={{ width: "13%" }}>
                                  <div className="p-2">{el.type === "DEBIT" && el.balance > 0 ? currencyFormat(el.balance) : 0}</div>
                                </div>
                                <div className="text-end" style={{ width: "13%" }}>
                                  <div className="p-2">{el.type === "DEBIT" && el.balance > 0 ? 0 : el.balance === 0 ? 0 : `${currencyFormat(Math.abs(el.balance))}`}</div>
                                </div>
                                <div className={debitCreditClass(el.type, el.categoryId, el.balance)} style={{ width: "13%" }}>
                                  <div className="p-2 fw-semibold">{debitCreditBalanceValue(el.type, el.categoryId, el.balance)}</div>
                                </div>
                              </div>
                            </div>

                            <Collapse isOpen={activeAccordion === el.id ? true : false} className="accordion-collapse bg-light border-0">
                              {accountItem?.id === el.id && !datearr && (
                                <div className="accordion-body p-0 fw-normal fs-12 text-dark">
                                  <div className="hstack cursor-pointer border-bottom ledger-content fw-semibold" style={{ width: "100%" }}>
                                    <div className="" style={{ width: "12%" }}>
                                      <div className="p-2 ps-5">
                                        {loading || accTransLoading ? (
                                          <div>
                                            <Spinner color="primary" type="grow" size={"sm"}>
                                              Loading...
                                            </Spinner>
                                            &nbsp;
                                            <Spinner color="success" type="grow" size={"sm"}>
                                              Loading...
                                            </Spinner>
                                            &nbsp;
                                          </div>
                                        ) : el?.closeat ? (
                                          handleValidDate(el?.closeat ?? "", "DD/MM/YYYY")
                                        ) : (
                                          "-"
                                        )}
                                      </div>
                                    </div>
                                    <div className="" style={{ width: "18%" }}>
                                      <div className="p-2 overflow-hidden"></div>
                                    </div>
                                    <div className="" style={{ width: "32%" }}>
                                      <div className="p-2 overflow-hidden">
                                        {"Saldo Awal"} {el.name}
                                      </div>
                                    </div>
                                    <div className="" style={{ width: "13%" }}>
                                      <div className="p-2 text-end">{currencyFormat(el.close_debit)}</div>
                                    </div>
                                    <div className="" style={{ width: "13%" }}>
                                      <div className="p-2 text-end">{currencyFormat(el.close_credit)}</div>
                                    </div>
                                    <div className="" style={{ width: "13%" }}>
                                      <div className="p-2 text-end">
                                        {debitCreditBalanceValue(el.type, el.categoryId, el.close_balance)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <SimpleBar
                                ref={transScrollRef}
                                style={{ maxHeight: "calc(100vh - 400px)" }}>
                                <div className="accordion-body p-0 fw-normal fs-12 text-dark ">
                                  {accountItem?.id === el.id &&
                                    (el.trans || [])
                                      .filter((f) => f.statusId === 3)
                                      .sort((a, b) => {
                                        return new Date(a?.transactionat).getTime() - new Date(b?.transactionat).getTime() || a?.code - b?.code;
                                      }).length === 0 && (
                                      <div className="accordion-body p-0 fw-normal fs-12 text-dark">
                                        <div className="hstack cursor-pointer border-bottom ledger-content fw-semibold" style={{ width: "100%" }}>
                                          <div className="" style={{ width: "62%" }}>
                                            <div className="p-2 ps-5 text-info">Belum ada transaksi pada {el.name}</div>
                                          </div>
                                          <div className="" style={{ width: "13%" }}>
                                            <div className="p-2 text-end"></div>
                                          </div>
                                          <div className="" style={{ width: "13%" }}>
                                            <div className="p-2 text-end"></div>
                                          </div>
                                          <div className="" style={{ width: "13%" }}>
                                            <div className="p-2 text-end"></div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  {/* ///// */}
                                  {accountItem?.id === el.id &&
                                    (el.trans || [])
                                      .filter((f) => f.statusId === 3)
                                      .sort((a, b) => {
                                        return new Date(a?.transactionat).getTime() - new Date(b?.transactionat).getTime() || a?.code - b?.code;
                                      })
                                      .map((transaction, o) => {
                                        let type;
                                        switch (transaction?.type) {
                                          case "CASH IN":
                                            type = <span className="badge text-uppercase badge-soft-success">{transaction?.type}</span>;
                                            break;
                                          case "CASH OUT":
                                            type = <span className="badge text-uppercase badge-soft-warning">{transaction?.type}</span>;
                                            break;
                                          case "RECEIVABLE":
                                            type = <span className="badge text-uppercase badge-soft-info">{transaction?.type}</span>;
                                            break;
                                          case "PAYABLE":
                                            type = <span className="badge text-uppercase badge-soft-danger">{transaction?.type}</span>;
                                            break;
                                          default:
                                            type = <span className="badge text-uppercase badge-soft-primary">{transaction?.type}</span>;
                                            break;
                                        }
                                        return (
                                          <Fragment key={o}>
                                            {(transaction.at_detail || [])
                                              .filter((f) => accountItem?.id === f.accId)
                                              .map((trans, i) => {
                                                let debit = trans.debit ? parseFloat(trans.debit) : 0;
                                                let credit = trans.credit ? parseFloat(trans.credit) : 0;
                                                if (debit > 0) {
                                                  temp_saldo = parseFloat(temp_saldo) + parseFloat(debit);
                                                }
                                                if (credit > 0) {
                                                  temp_saldo = parseFloat(temp_saldo) - parseFloat(credit);
                                                }

                                                if (datearr) {
                                                  if (isDateBetween(handleValidDate(transaction?.transactionat, "YYYY/MM/DD"), startat, endat)) {
                                                    return (
                                                      <div
                                                        key={i}
                                                        className="hstack cursor-pointer border-bottom ledger-content"
                                                        style={{ width: "100%" }}
                                                        onClick={() => {
                                                          handleGetAccTrans("one", transaction?.id, "");
                                                          toggle();
                                                        }}
                                                      >
                                                        <div className="d-flex align-items-center gap-3" style={{ width: "12%" }}>
                                                          <Button
                                                            color="light"
                                                            className="btn-sm"
                                                            onClick={(e) => {
                                                              e.stopPropagation();
                                                              e.preventDefault();
                                                              handleGetAccTrans("one", transaction?.id, "edit");
                                                            }}
                                                          >
                                                            <i className="ri-edit-2-line fs-15"></i>
                                                          </Button>
                                                          <div>{handleValidDate(transaction?.transactionat, "DD/MM/YYYY")}</div>
                                                        </div>
                                                        <div className="" style={{ width: "18%" }}>
                                                          <div className="ps-2 pe-2 pt-1 pb-1">
                                                            {transaction?.transaction_no} {type}
                                                          </div>
                                                        </div>
                                                        <div className="" style={{ width: "32%" }}>
                                                          <div className="ps-2 pe-2 pt-1 pb-1 overflow-hidden">
                                                            {transaction?.description}
                                                            <ul className={transaction?.at_purchase?.purchase_detail ? "d-none" : ""} style={{ marginLeft: "-20px" }}>
                                                              {(transaction?.at_purchase?.purchase_detail || []).map((purchase, pi) => {
                                                                return <li className="mb-0 fs-11" key={pi}>{purchase.cvl_account} - {purchase.name} {currencyFormat(purchase.quantity)} * Rp {currencyFormat(purchase.amount)} = {currencyFormat(purchase.amount_total)} </li>
                                                              })}
                                                            </ul>
                                                          </div>
                                                        </div>
                                                        <div className="text-end " style={{ width: "13%" }}>
                                                          <div className="ps-2 pe-2 pt-1 pb-1">{trans ? currencyFormat(trans.debit) : 0}</div>
                                                        </div>
                                                        <div className="text-end " style={{ width: "13%" }}>
                                                          <div className="ps-2 pe-2 pt-1 pb-1">{trans ? currencyFormat(trans.credit) : 0}</div>
                                                        </div>
                                                        <div className={debitCreditClass(el.type, el.categoryId, temp_saldo)} style={{ width: "13%" }}>
                                                          <div className="ps-2 pe-2 pt-1 pb-1 fw-semibold">
                                                            {debitCreditBalanceValue(el.type, el.categoryId, temp_saldo)}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    );
                                                  } else {
                                                    return <></>;
                                                  }
                                                } else {
                                                  return (
                                                    <div
                                                      key={i}
                                                      className="hstack cursor-pointer border-bottom ledger-content"
                                                      style={{ width: "100%" }}
                                                      onClick={() => {
                                                        handleGetAccTrans("one", transaction?.id, "");
                                                        toggle();
                                                      }}
                                                    >
                                                      <div className="d-flex align-items-center gap-3" style={{ width: "12%" }}>
                                                        <Button
                                                          color="light"
                                                          className="btn-sm"
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            e.preventDefault();
                                                            handleGetAccTrans("one", transaction?.id, "edit");
                                                          }}
                                                        >
                                                          <i className="ri-edit-2-line fs-15"></i>
                                                        </Button>
                                                        <div>{handleValidDate(transaction?.transactionat, "DD/MM/YYYY")}</div>
                                                      </div>
                                                      <div className="" style={{ width: "18%" }}>
                                                        <div className="ps-2 pe-2 pt-1 pb-1">
                                                          {transaction?.transaction_no} {type}
                                                        </div>
                                                      </div>
                                                      <div className="" style={{ width: "32%" }}>
                                                        <div className="ps-2 pe-2 pt-1 pb-1 overflow-hidden">
                                                          {transaction?.description}
                                                          <ul className={transaction?.at_purchase?.purchase_detail ? "d-none" : ""} style={{ marginLeft: "-20px" }}>
                                                            {(transaction?.at_purchase?.purchase_detail || []).map((purchase, pi) => {
                                                              return <li className="mb-0 fs-11" key={pi}>{purchase.cvl_account} - {purchase.name} {currencyFormat(purchase.quantity)} * Rp {currencyFormat(purchase.amount)} = {currencyFormat(purchase.amount_total)} </li>
                                                            })}
                                                          </ul>
                                                        </div>
                                                      </div>
                                                      <div className="text-end " style={{ width: "13%" }}>
                                                        <div className="ps-2 pe-2 pt-1 pb-1">{trans ? currencyFormat(trans.debit) : 0}</div>
                                                      </div>
                                                      <div className="text-end " style={{ width: "13%" }}>
                                                        <div className="ps-2 pe-2 pt-1 pb-1">{trans ? currencyFormat(trans.credit) : 0}</div>
                                                      </div>
                                                      <div className={debitCreditClass(el.type, el.categoryId, temp_saldo)} style={{ width: "13%" }}>
                                                        <div className="ps-2 pe-2 pt-1 pb-1 fw-semibold">
                                                          {debitCreditBalanceValue(el.type, el.categoryId, temp_saldo)}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  );
                                                }
                                              })}
                                          </Fragment>
                                        );
                                      })}
                                  {accountItem?.id === el.id &&
                                    (el.trans || [])
                                      .filter((f) => f.statusId === 3)
                                      .sort((a, b) => {
                                        return new Date(a?.transactionat).getTime() - new Date(b?.transactionat).getTime() || a?.code - b?.code;
                                      }).length > 0 && (
                                      <div className="accordion-body p-0 fw-normal fs-12 text-dark ledger-trans-total">
                                        <div className="hstack cursor-pointer border-bottom ledger-content fw-semibold" style={{ width: "100%" }}>
                                          <div className="" style={{ width: "62%" }}>
                                            <div className="p-2 ps-5 text-end text-primary fs-11">TOTAL</div>
                                          </div>
                                          <div className="" style={{ width: "13%" }}>
                                            <div className="p-2 text-end text-primary fs-13">
                                              {accountItem?.id === el.id && datearr ?
                                                currencyFormat((el.trans || [])
                                                  .filter((f) => f.statusId === 3 && isDateBetween(handleValidDate(f?.transactionat, "YYYY/MM/DD"), startat, endat))
                                                  .flatMap(x => x.at_detail)
                                                  .filter((f) => accountItem?.id === f.accId)
                                                  .map(x => x.debit)
                                                  .reduce((s, n) => s + parseFloat(n || 0), 0))
                                                :
                                                currencyFormat((el.trans || [])
                                                  .filter((f) => f.statusId === 3)
                                                  .flatMap(x => x.at_detail)
                                                  .filter((f) => accountItem?.id === f.accId)
                                                  .map(x => x.debit)
                                                  .reduce((s, n) => s + parseFloat(n || 0), 0))}
                                            </div>
                                          </div>
                                          <div className="" style={{ width: "13%" }}>
                                            <div className="p-2 text-end text-primary fs-13">
                                              {accountItem?.id === el.id && datearr ?
                                                currencyFormat((el.trans || [])
                                                  .filter((f) => f.statusId === 3 && isDateBetween(handleValidDate(f?.transactionat, "YYYY/MM/DD"), startat, endat))
                                                  .flatMap(x => x.at_detail)
                                                  .filter((f) => accountItem?.id === f.accId)
                                                  .map(x => x.credit)
                                                  .reduce((s, n) => s + parseFloat(n || 0), 0))
                                                :
                                                currencyFormat((el.trans || [])
                                                  .filter((f) => f.statusId === 3)
                                                  .flatMap(x => x.at_detail)
                                                  .filter((f) => accountItem?.id === f.accId)
                                                  .map(x => x.credit)
                                                  .reduce((s, n) => s + parseFloat(n || 0), 0))}
                                            </div>
                                          </div>
                                          <div className="" style={{ width: "13%" }}>
                                            <div className="p-2 text-end"></div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </SimpleBar>
                            </Collapse>
                          </AccordionItem>
                        </Accordion>
                      </div>
                    );
                  })}
                </div>
                <Modal id="showModal" isOpen={modal} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    DETAIL TRANSAKSI #{info.transaction_no}
                  </ModalHeader>
                  <ModalBody>
                    <div className="table-responsive mb-3 row">
                      <div className="col-lg-6">
                        <p className="text-muted mb-0 text-uppercase fw-semibold">Jumlah</p>
                        <p className=" mb-1text-uppercase fw-semibold">{currencyFormat(info.amount)}</p>
                        <p className="text-muted mb-0 text-uppercase fw-semibold">Proyek / Cabang</p>
                        <p className=" mb-1text-uppercase fw-semibold">{info.at_branch && info.at_branch.name}</p>
                        <p className="text-muted mb-0 text-uppercase fw-semibold">Departemen</p>
                        <p className=" mb-1text-uppercase fw-semibold">{info.at_department ? info.at_department.name : "-"}</p>
                        <p className="text-muted mb-0 text-uppercase fw-semibold">Anggaran</p>
                        <p className=" mb-1text-uppercase fw-semibold">{info.at_cvl_account ? info.at_cvl_account.name : "-"}</p>
                        <p className="text-muted mb-0 text-uppercase fw-semibold">Cash Flow </p>
                        <p className=" mb-1text-uppercase fw-semibold">{info.at_budget ? info.at_budget.name : "-"}</p>
                      </div>
                      <div className="col-lg-6">
                        <p className="text-muted mb-0 text-uppercase fw-semibold">Metode Bayar</p>
                        <p className=" mb-1text-uppercase fw-semibold">{info.at_pm ? info.at_pm.name : "-"}</p>
                        <p className="text-muted mb-0 text-uppercase fw-semibold">Dibuat Oleh</p>
                        <p className=" mb-1text-uppercase fw-semibold">{info.at_createdby ? info.at_createdby.name : "-"},  {handleValidDate(info.createdat)}</p>
                        <p className="text-muted mb-0 text-uppercase fw-semibold">Disetujui Oleh</p>
                        <p className=" mb-1text-uppercase fw-semibold">{info.at_approvedby ? info.at_approvedby.name : "-"},  {handleValidDate(info.approvedat)}</p>
                        <p className="text-muted mb-0 text-uppercase fw-semibold">Diedit Oleh</p>
                        <p className=" mb-1text-uppercase fw-semibold">{info.at_updatedby ? info.at_updatedby.name : "-"},  {handleValidDate(info.updatedat)}</p>
                      </div>
                    </div>
                    <div className="table-responsive mb-3">
                      <p className="text-muted mb-2 text-uppercase fw-semibold">Journal</p>
                      <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                        <thead>
                          <tr className="table-active">
                            <th scope="col" style={{ width: "20px" }}>
                              #
                            </th>
                            <th scope="col" className="text-start">
                              Akun
                            </th>
                            <th scope="col" style={{ width: "90px" }}>
                              Debit
                            </th>
                            <th scope="col" style={{ width: "90px" }}>
                              Credit
                            </th>
                          </tr>
                        </thead>
                        <tbody id="products-list">
                          {(info.at_detail || []).map((el, i) => {
                            return (
                              <tr key={el.id} className="product">
                                <th scope="row" className="product-id">
                                  {i + 1}
                                </th>
                                <td className="text-start fs-12 pt-2 pb-2">
                                  <p className="fw-semibold mb-0">{el.at_detail_account && el.at_detail_account.code}</p>
                                  <p className="mb-0" style={{ maxWidth: "120px", textOverflow: "ellipsis" }}>
                                    {el.at_detail_account && el.at_detail_account.name}
                                  </p>
                                </td>
                                <td className="fs-12 fw-semibold">{parseFloat(el.debit) > 0 ? currencyFormat(parseFloat(el.debit)) : ""}</td>
                                <td className="fs-12 fw-semibold">{parseFloat(el.credit) > 0 ? currencyFormat(parseFloat(el.credit)) : ""}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                    <div className="mb-4">
                      <div className="alert alert-info">
                        <p className="fw-semibold mb-1">NOTES:</p>
                        <p className="mb-0">{info.description}</p>
                      </div>
                    </div>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          setModal(false);
                        }}
                      >
                        TUTUP
                      </button>
                    </div>
                  </div>
                </Modal>

                <Modal id="showModal" isOpen={modalClose} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleClose}>
                    {"Tutup Buku"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationClose.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="cclient" className="form-label">
                              Client
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="cclient"
                              value={validationClose.values.cclient}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                validationClose.setFieldValue("cclient", e);
                                dispatch(setClientSelect(e));
                              }}
                              options={clientList}
                            ></Select>
                            {validationClose.touched.cclient && validationClose.errors.cclient && (
                              <p className="text-danger" type="invalid">
                                {validationClose.errors.cclient}
                              </p>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="ccompany" className="form-label">
                              Company
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="ccompany"
                              value={validationClose.values.ccompany}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                validationClose.setFieldValue("ccompany", e);
                                dispatch(setCompanySelect(e));
                              }}
                              options={companyList}
                            ></Select>
                            {validationClose.touched.ccompany && validationClose.errors.ccompany && (
                              <p className="text-danger" type="invalid">
                                {validationClose.errors.ccompany}
                              </p>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="type" className="form-label">
                              Type
                            </Label>
                            <Select
                              name="ccompany"
                              value={validationClose.values.type}
                              placeholder="Pilih Type"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                setSelectTytpe(e);
                              }}
                              options={[
                                { label: "MONTHLY", value: "monthly" },
                                { label: "YEARLY", value: "yearly" },
                              ]}
                            ></Select>
                            {validationClose.touched.ccompany && validationClose.errors.ccompany && (
                              <p className="text-danger" type="invalid">
                                {validationClose.errors.type}
                              </p>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Tanggal
                            </Label>
                            <div className="search-box me-2 mb-3 col-12">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal Closing"
                                options={{
                                  mode: "single",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setInputDate(dateStr);
                                }}
                                value={validationClose.values.date}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            toggleClose();
                          }}
                        >
                          Tutup
                        </button>
                        <button
                          type="button"
                          className="btn btn-success"
                          onClick={() => {
                            toggleBalance();
                            handleItem();
                          }}
                        >
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Tampilkan Saldo Akhir"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModal" isOpen={modalBalance} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleBalance}>
                    {"Tutup Buku"}
                  </ModalHeader>
                  <div className="px-4">
                    <div className="search-box mt-4 d-inline-block col-12">
                      <input onChange={(e) => setSearchValueModal(e.target.value)} id="search-bar-awal-0" type="text" className="form-control search" placeholder={`${filteredItems.length} Cari...`} value={searchValueModal} />
                      <i className="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationClose.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <Table className="table table-borderless table-nowrap align-middle mb-0 ms-auto">
                        <thead>
                          <tr>
                            <td>Akun</td>
                            <td>Nama Akun</td>
                            <td></td>
                            <td>Debit</td>
                            <td>Kredit</td>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredItems.map((item, idxAccount) => {
                            let labelDC = "";
                            switch (item.default) {
                              case "CREDIT":
                                labelDC = <span className="badge text-uppercase badge-soft-warning"> {item.default} </span>;
                                break;
                              case "DEBIT":
                                labelDC = <span className="badge text-uppercase badge-soft-success"> {item.default} </span>;
                                break;
                              default:
                                labelDC = <span className="badge text-uppercase badge-soft-warning"> {item.default} </span>;
                                break;
                            }
                            return (
                              <tr key={"idxAccount" + idxAccount}>
                                <td>{item.code}</td>
                                <td>{item.name}</td>
                                <td>{labelDC}</td>
                                <td className="text-end">
                                  <Input
                                    name="debit"
                                    id="debit-field"
                                    className="form-control"
                                    placeholder="Enter Debit"
                                    type="number"
                                    onChange={(e) => {
                                      validationClose.setFieldValue(`tableItem[idxAccount].debit`, e.target.value);
                                      tableItem[idxAccount].debit = e.target.value;
                                      filteredItems[idxAccount].debit = e.target.value;
                                    }}
                                    onBlur={validationClose.handleBlur}
                                    value={filteredItems[idxAccount].debit}
                                  />
                                </td>
                                <td className="text-end">
                                  <Input
                                    name="credit"
                                    id="credit-field"
                                    className="form-control"
                                    placeholder="Enter Credit"
                                    type="number"
                                    onChange={(e) => {
                                      validationClose.setFieldValue(`tableItem[idxAccount].credit`, e.target.value);
                                      tableItem[idxAccount].credit = e.target.value;
                                    }}
                                    onBlur={validationClose.handleBlur}
                                    value={filteredItems[idxAccount].credit}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                      <div className="modal-footer">
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              toggleBalance();
                            }}
                          >
                            Tutup
                          </button>
                          <button type="submit" className="btn btn-success">
                            <span className="d-flex align-items-center">
                              <span className="flex-grow-1 me-2">Simpan Akun</span>
                              {loading && (
                                <Spinner size="sm" className="flex-shrink-0" role="status">
                                  Loading...
                                </Spinner>
                              )}
                            </span>
                          </button>
                        </div>
                      </div>
                    </ModalBody>
                  </Form>
                </Modal>

                {/* /// */}
                <Modal id="showModal" isOpen={modalTrans} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggleTrans}>
                    {isEditTrans ? "EDIT TRANSAKSI" : "JURNAL UMUM"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationTrans.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <CardBody className="border-bottom border-bottom-dashed p-3">
                        <Row>
                          <Col lg={7}>
                            <Row>
                              <div className="mb-3 col-lg-6">
                                <Select
                                  name="type"
                                  placeholder="Jenis Transaksi"
                                  value={validationTrans.values.type}
                                  onChange={(e) => {
                                    // let arr = [{
                                    //   itemId: 0,
                                    //   isPrimary: true,
                                    //   description: "",
                                    //   sort_order: 1,
                                    //   debit: 0,
                                    //   credit: 0,
                                    //   accId: "",
                                    //   amount: 0,
                                    //   acc: ""
                                    // },
                                    // {
                                    //   itemId: 0,
                                    //   isPrimary: false,
                                    //   description: "",
                                    //   sort_order: 2,
                                    //   debit: 0,
                                    //   credit: 0,
                                    //   accId: "",
                                    //   amount: 0,
                                    //   acc: ""
                                    // }];
                                    validationTrans.setFieldValue("type", e);
                                    //validationTrans.setFieldValue("items", arr);
                                  }}
                                  options={transTypeData}
                                ></Select>
                                {validationTrans.touched.type && validationTrans.errors.type && (
                                  <small className="text-danger" type="invalid">
                                    {validationTrans.errors.type}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3 col-lg-6">
                                <Flatpickr
                                  className="form-control"
                                  id="datepicker-publish-input"
                                  placeholder="Pilih Tanggal"
                                  options={{
                                    mode: "single",
                                    dateFormat: "Y/m/d",
                                  }}
                                  onChange={(selectedDates, dateStr) => {
                                    validationTrans.setFieldValue("transactionat", dateStr);
                                  }}
                                  value={validationTrans.values.transactionat ?? ""}
                                />
                                {validationTrans.touched.transactionat && validationTrans.errors.transactionat && (
                                  <small className="text-danger" type="invalid">
                                    {validationTrans.errors.transactionat}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3 col-lg-6">
                                <Select
                                  name="user"
                                  value={validationTrans.values.user}
                                  placeholder="Pilih Kontak"
                                  onChange={(e) => {
                                    validationTrans.setFieldValue("user", e);
                                  }}
                                  options={userList}
                                ></Select>
                                {validationTrans.touched.user && validationTrans.errors.user && (
                                  <small className="text-danger" type="invalid">
                                    {validationTrans.errors.user}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3 col-lg-6">
                                <div className="position-relative">
                                  <Select
                                    name="department"
                                    value={validationTrans.values.department}
                                    placeholder="Pilih Departemen"
                                    onChange={(e) => {
                                      validationTrans.setFieldValue("department", e);
                                    }}
                                    options={departmentList}
                                  ></Select>
                                  <div
                                    className="position-absolute"
                                    style={{
                                      top: "12px",
                                      left: "-24px",
                                    }}
                                  >
                                    {departmentLoading && (
                                      <Spinner color="primary" size="sm">
                                        Loading...
                                      </Spinner>
                                    )}
                                  </div>
                                </div>
                                {validationTrans.touched.department && validationTrans.errors.department && (
                                  <p className="invalid-feedback d-block" type="invalid">
                                    {validationTrans.errors.department}
                                  </p>
                                )}
                              </div>
                              <div className="mb-3 col-lg-6">
                                <Select
                                  name="branch"
                                  placeholder="Pilih Cabang"
                                  value={validationTrans.values.branch}
                                  onChange={(e) => {
                                    validationTrans.setFieldValue("branch", e);
                                    handleGetCivilBudget(companySelected.value, e.value);
                                    setBranchIdSelected(e.value);
                                    handleGetBudget(companySelected.value, e.value);
                                  }}
                                  options={branchList}
                                ></Select>
                                {validationTrans.touched.branch && validationTrans.errors.branch && (
                                  <small className="text-danger" type="invalid">
                                    {validationTrans.errors.branch}
                                  </small>
                                )}
                              </div>
                              <div className="mb-3 col-lg-6">
                                <Select
                                  name="budget"
                                  value={validationTrans.values.budget}
                                  placeholder="Pilih Cashflow"
                                  onChange={(e) => {
                                    validationTrans.setFieldValue("budget", e);
                                  }}
                                  options={budgetList}
                                ></Select>
                                {validationTrans.touched.budget && validationTrans.errors.budget && (
                                  <small className="text-danger" type="invalid">
                                    {validationTrans.errors.budget}
                                  </small>
                                )}
                              </div>
                              <div>
                                <div className="mb-3">
                                  <div className={"form-check form-switch form-switch-success"} dir="ltr">
                                    <Input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customSwitchsizesm4"
                                      checked={isLegal}
                                      onChange={(e) => {
                                        setIsLegal(e.target.checked);
                                        if (e.target.checked === true) {
                                          if (accTrans && accTrans.legal) validationTrans.setFieldValue("legal", accTrans.legal);
                                          if (accTrans && accTrans.legal_asset) validationTrans.setFieldValue("legal_asset", accTrans.legal_asset);
                                          if (accTrans && accTrans.legal_master) validationTrans.setFieldValue("legal_master", accTrans.legal_master);
                                          if (accTrans && accTrans.legal_permission) validationTrans.setFieldValue("legal_permission", accTrans.legal_permission);
                                          if (accTrans && accTrans.legal_fraction) validationTrans.setFieldValue("legal", accTrans.legal_fraction);
                                        } else {
                                          validationTrans.setFieldValue("legal", "");
                                          validationTrans.setFieldValue("legal_asset", "");
                                          validationTrans.setFieldValue("legal_master", "");
                                          validationTrans.setFieldValue("legal_permission", "");
                                          validationTrans.setFieldValue("legal_fraction", "");
                                        }

                                        setIsCivilContract(false);
                                        setIsPurchase(false);
                                        setIsSales(false);
                                        setIsBudget(false);
                                        validationTrans.setFieldValue("civilContract", "");
                                        validationTrans.setFieldValue("purchase", "");
                                        validationTrans.setFieldValue("sales", "");
                                        validationTrans.setFieldValue("cvl_budget", "");
                                        handleGetLegal(validationTrans.values.company.value);
                                        handleGetLegalFraction(validationTrans.values.company.value, validationTrans.values.branch.value);
                                        handleGetLegalMaster(validationTrans.values.company.value, validationTrans.values.branch.value);
                                        handleGetLegalPermisson(validationTrans.values.company.value, validationTrans.values.branch.value);
                                      }}
                                    />
                                    <Label className="form-check-label" for="customSwitchsizesm4">
                                      Transaksi terkait dengan Pertanahan / Perizinan?
                                      {(legalFractionLoading || legalMasterLoading || legalPermissionLoading || legalLoading) && (
                                        <>
                                          <Spinner color="primary" type="grow" size={"sm"} className="ms-2">
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                          <Spinner color="success" type="grow" size={"sm"}>
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                        </>
                                      )}
                                    </Label>
                                  </div>
                                  <div className={isBudget ? "d-none" : "row"}>
                                    <div className="col-lg-6">
                                      <Select
                                        name="legal"
                                        className={isLegal ? "mt-3" : "mt-3 d-none"}
                                        value={validationTrans.values.legal}
                                        placeholder="Pilih SPH"
                                        onChange={(e) => {
                                          validationTrans.setFieldValue("legal", e);
                                          validationTrans.setFieldValue("legal_asset", "");
                                          validationTrans.setFieldValue("legal_master", "");
                                          validationTrans.setFieldValue("legal_permission", "");
                                          validationTrans.setFieldValue("legal_fraction", "");
                                        }}
                                        options={legalList}
                                      ></Select>
                                    </div>
                                    <div className="col-lg-6">
                                      <Select
                                        name="legal_asset"
                                        className={isLegal ? "mt-3" : "mt-3 d-none"}
                                        value={validationTrans.values.legal_asset}
                                        placeholder="Pilih Tanah Asset"
                                        onChange={(e) => {
                                          validationTrans.setFieldValue("legal", "");
                                          validationTrans.setFieldValue("legal_asset", e);
                                          validationTrans.setFieldValue("legal_master", "");
                                          validationTrans.setFieldValue("legal_permission", "");
                                          validationTrans.setFieldValue("legal_fraction", "");
                                        }}
                                        options={legalAssetList}
                                      ></Select>
                                    </div>
                                    <div className="col-lg-6">
                                      <Select
                                        name="legal_master"
                                        className={isLegal ? "mt-3" : "mt-3 d-none"}
                                        value={validationTrans.values.legal_master}
                                        placeholder="Pilih Sertifikat Induk"
                                        onChange={(e) => {
                                          validationTrans.setFieldValue("legal", "");
                                          validationTrans.setFieldValue("legal_asset", "");
                                          validationTrans.setFieldValue("legal_master", e);
                                          validationTrans.setFieldValue("legal_permission", "");
                                          validationTrans.setFieldValue("legal_fraction", "");
                                        }}
                                        options={legalMasterList}
                                      ></Select>
                                    </div>
                                    <div className="col-lg-6">
                                      <Select
                                        name="legal_permission"
                                        className={isLegal ? "mt-3" : "mt-3 d-none"}
                                        value={validationTrans.values.legal_permission}
                                        placeholder="Pilih Perizinan"
                                        onChange={(e) => {
                                          validationTrans.setFieldValue("legal", "");
                                          validationTrans.setFieldValue("legal_asset", "");
                                          validationTrans.setFieldValue("legal_master", "");
                                          validationTrans.setFieldValue("legal_permission", e);
                                          validationTrans.setFieldValue("legal_fraction", "");
                                        }}
                                        options={legalPermissionList}
                                      ></Select>
                                    </div>
                                    <div className="col-lg-6 d-none">
                                      <Select
                                        name="legal_fraction"
                                        className={isLegal ? "mt-3" : "mt-3 d-none"}
                                        value={validationTrans.values.legal_fraction}
                                        placeholder="Pilih Sertifikat Pecahan"
                                        onChange={(e) => {
                                          validationTrans.setFieldValue("legal", "");
                                          validationTrans.setFieldValue("legal_asset", "");
                                          validationTrans.setFieldValue("legal_master", "");
                                          validationTrans.setFieldValue("legal_permission", "");
                                          validationTrans.setFieldValue("legal_fraction", e);
                                        }}
                                        options={legalFractionList}
                                      ></Select>
                                    </div>
                                  </div>
                                </div>
                                <div className={"mb-3"}>
                                  <div className="form-check form-switch form-switch-success" dir="ltr">
                                    <Input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customSwitchsizesm1"
                                      checked={isBudget}
                                      onChange={(e) => {
                                        handleGetCivilBudget(validationTrans.values.company.value, validationTrans.values.branch.value);
                                        setIsBudget(e.target.checked);
                                        if (e.target.checked === false) {
                                          validationTrans.setFieldValue("cvl_budget", "");
                                        }

                                        validationTrans.setFieldValue("legal", "");
                                        validationTrans.setFieldValue("legal_asset", "");
                                        validationTrans.setFieldValue("legal_master", "");
                                        validationTrans.setFieldValue("legal_permission", "");
                                        validationTrans.setFieldValue("legal_fraction", "");
                                        setIsLegal(false);
                                        setIsSales(false);
                                        validationTrans.setFieldValue("sales", "");
                                      }}
                                    />
                                    <Label className="form-check-label" for="customSwitchsizesm1">
                                      Transaksi terkait dengan RAB ?
                                      {civilBudgetLoading && (
                                        <>
                                          <Spinner color="primary" type="grow" size={"sm"} className="ms-2">
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                          <Spinner color="success" type="grow" size={"sm"}>
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                        </>
                                      )}
                                    </Label>
                                  </div>
                                  <Select
                                    name="cvl_budget"
                                    className={isBudget ? "mt-2" : "mt-2 d-none"}
                                    value={validationTrans.values.cvl_budget}
                                    placeholder="Pilih Item Anggaran Teknik Terkait"
                                    onChange={(e) => {
                                      validationTrans.setFieldValue("cvl_budget", e);
                                    }}
                                    options={civilBudgetDetailList}
                                  ></Select>
                                </div>
                                <div className={"mb-3"}>
                                  <div className="form-check form-switch form-switch-success" dir="ltr">
                                    <Input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customSwitchsizesm5"
                                      checked={isCivilContract}
                                      onChange={(e) => {
                                        setIsCivilContract(e.target.checked);
                                        if (e.target.checked === true) {
                                          if (accTrans && accTrans.civilContract) {
                                            validationTrans.setFieldValue("civilContract", accTrans.civilContract);
                                          }
                                        } else {
                                          validationTrans.setFieldValue("civilContract", "");
                                        }

                                        setIsLegal(false);
                                        setIsPurchase(false);
                                        setIsSales(false);
                                        setIsBudget(false);
                                        validationTrans.setFieldValue("legal", "");
                                        validationTrans.setFieldValue("legal_asset", "");
                                        validationTrans.setFieldValue("legal_master", "");
                                        validationTrans.setFieldValue("legal_permission", "");
                                        validationTrans.setFieldValue("legal_fraction", "");
                                        validationTrans.setFieldValue("purchase", "");
                                        validationTrans.setFieldValue("sales", "");
                                        handleGetCivilContract(validationTrans.values.company.value, validationTrans.values.branch.value);
                                      }}
                                    />
                                    <Label className="form-check-label" for="customSwitchsizesm5">
                                      Transaksi terkait dengan SPK?{" "}
                                      {civilContractLoading && (
                                        <>
                                          <Spinner color="primary" type="grow" size={"sm"} className="ms-2">
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                          <Spinner color="success" type="grow" size={"sm"}>
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                        </>
                                      )}
                                    </Label>
                                  </div>
                                  <Select
                                    name="civilContract"
                                    className={isCivilContract ? "mt-3" : "mt-3 d-none"}
                                    value={validationTrans.values.civilContract}
                                    placeholder="Pilih SPK Terkait"
                                    onChange={(e) => {
                                      validationTrans.setFieldValue("civilContract", e);
                                    }}
                                    options={civilContractList}
                                  ></Select>
                                </div>
                                <div className={"mb-3"}>
                                  <div className="form-check form-switch form-switch-success" dir="ltr">
                                    <Input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customSwitchsizesm3"
                                      checked={isPurchase}
                                      onChange={(e) => {
                                        setIsPurchase(e.target.checked);
                                        if (e.target.checked === true) {
                                          if (accTrans && accTrans.purchase) {
                                            validationTrans.setFieldValue("purchase", accTrans.purchase);
                                          }
                                        } else {
                                          validationTrans.setFieldValue("purchase", "");
                                        }
                                        setIsSales(false);
                                        validationTrans.setFieldValue("sales", "");
                                        setIsCivilContract(false);
                                        validationTrans.setFieldValue("civilContract", "");
                                        setIsLegal(false);
                                        validationTrans.setFieldValue("legal", "");
                                        validationTrans.setFieldValue("legal_asset", "");
                                        validationTrans.setFieldValue("legal_master", "");
                                        validationTrans.setFieldValue("legal_permission", "");
                                        validationTrans.setFieldValue("legal_fraction", "");
                                        handleGetPurchase(validationTrans.values.company.value, validationTrans.values.branch.value);
                                      }}
                                    />
                                    <Label className="form-check-label" for="customSwitchsizesm3">
                                      Transaksi terkait dengan Pembelian?
                                      {purchaseLoading && (
                                        <>
                                          <Spinner color="primary" type="grow" size={"sm"} className="ms-2">
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                          <Spinner color="success" type="grow" size={"sm"}>
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                        </>
                                      )}
                                    </Label>
                                  </div>
                                  <Select
                                    name="purchase"
                                    className={isPurchase ? "mt-3" : "mt-3 d-none"}
                                    value={validationTrans.values.purchase}
                                    placeholder="Pilih Transaksi Pembelian Terkait"
                                    onChange={(e) => {
                                      validationTrans.setFieldValue("purchase", e);
                                    }}
                                    options={purchaseList}
                                  ></Select>
                                </div>
                                <div className={"mb-3"}>
                                  <div className="form-check form-switch form-switch-success" dir="ltr">
                                    <Input
                                      type="checkbox"
                                      className="form-check-input"
                                      id="customSwitchsizesm2"
                                      checked={isSales}
                                      onChange={(e) => {
                                        setIsSales(e.target.checked);
                                        if (e.target.checked === true) {
                                          if (accTrans && accTrans.sales) {
                                            validationTrans.setFieldValue("sales", accTrans.sales);
                                          }
                                        } else {
                                          validationTrans.setFieldValue("sales", "");
                                        }
                                        setIsLegal(false);
                                        validationTrans.setFieldValue("legal", "");
                                        validationTrans.setFieldValue("legal_asset", "");
                                        validationTrans.setFieldValue("legal_master", "");
                                        validationTrans.setFieldValue("legal_permission", "");
                                        validationTrans.setFieldValue("legal_fraction", "");
                                        setIsPurchase(false);
                                        validationTrans.setFieldValue("purchase", "");
                                        setIsCivilContract(false);
                                        validationTrans.setFieldValue("civilContract", "");
                                        setIsBudget(false);
                                        validationTrans.setFieldValue("cvl_budget", "");
                                        handleGetSales(validationTrans.values.company.value, validationTrans.values.branch.value);
                                      }}
                                    />
                                    <Label className="form-check-label" for="customSwitchsizesm2">
                                      Transaksi terkait dengan Penjualan?{" "}
                                      {salesLoading && (
                                        <>
                                          <Spinner color="primary" type="grow" size={"sm"} className="ms-2">
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                          <Spinner color="success" type="grow" size={"sm"}>
                                            Loading...
                                          </Spinner>
                                          &nbsp;
                                        </>
                                      )}
                                    </Label>
                                  </div>
                                  <Select
                                    name="sales"
                                    className={isSales ? "mt-3" : "mt-3 d-none"}
                                    value={validationTrans.values.sales}
                                    placeholder="Pilih Transaksi Penjualan Terkait"
                                    onChange={(e) => {
                                      validationTrans.setFieldValue("sales", e);
                                    }}
                                    options={salesList}
                                  ></Select>
                                </div>
                              </div>
                              <div className="mb-3">
                                <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan (jika ada)" name="description" rows={validationTrans.values.release.length ? 5 : 2} value={validationTrans.values.description ?? ""} onBlur={validationTrans.handleBlur} onChange={validationTrans.handleChange} invalid={validationTrans.touched.description && validationTrans.errors.description ? true : false} />
                              </div>
                            </Row>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={4}>
                            <div className="mb-3">
                              <div className="position-relative">
                                <Select
                                  name="client"
                                  value={validationTrans.values.client}
                                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                                  placeholder="Pilih Grup Usaha"
                                  onChange={(e) => {
                                    dispatch(setClientSelect(e));
                                    validationTrans.setFieldValue("client", e);
                                  }}
                                  options={clientList}
                                ></Select>
                                <div className="position-absolute" style={{ top: "12px", left: "-24px" }}>
                                  {clientLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </div>
                              </div>
                              {validationTrans.touched.client && validationTrans.errors.client && (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validationTrans.errors.client}
                                </p>
                              )}
                            </div>
                            <div className="mb-3">
                              <div className="position-relative">
                                <Select
                                  name="company"
                                  value={validationTrans.values.company}
                                  placeholder="Pilih Perusahaan"
                                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                                  onChange={(e) => {
                                    dispatch(setCompanySelect(e));
                                    setAccountingList([]);
                                    setUserList([]);
                                    setTaxList([]);
                                    setDepartmentList([]);
                                    setCivilBudgetDetailList([]);
                                    setPaymentMethodList([]);
                                    setBranchList([]);
                                    validationTrans.resetForm({});
                                    validationTrans.setFieldValue("company", e);
                                    handleGetAccTrans(companySelected.value, branchSelected.value);
                                  }}
                                  options={companyList}
                                ></Select>
                                <div className="position-absolute" style={{ top: "12px", left: "-24px" }}>
                                  {companyLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </div>
                              </div>
                              {validationTrans.touched.company && validationTrans.errors.company && (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validationTrans.errors.company}
                                </p>
                              )}
                            </div>
                            <div className="mb-3">
                              <Select
                                name="tag"
                                value={validationTrans.values.tag}
                                placeholder="Pilih Tag"
                                onChange={(e) => {
                                  validationTrans.setFieldValue("tag", e);
                                  setAccTag(e.value)
                                }}
                                options={tagList}
                              ></Select>
                              {validationTrans.touched.tag && validationTrans.errors.tag && (
                                <small className="text-danger" type="invalid">
                                  {validationTrans.errors.tag}
                                </small>
                              )}
                            </div>
                            <div className="mb-3">
                              <CurrencyInput
                                disabled={(accTrans?.approval || accTrans?.statusId === 3) && userType !== "admin" && isEditTrans ? true : false}
                                id="amount"
                                name="amount"
                                prefix="Rp. "
                                style={{ border: "1px solid #ccc", width: "100%" }}
                                className="form-control-lg fw-semibold"
                                placeholder="Input Nilai Transaksi"
                                value={validationTrans.values.amount}
                                decimalsLimit={2}
                                onFocus={(e) => e.target.select()}
                                onValueChange={(value, name, values) => {
                                  validationTrans.setFieldValue("amount", value);
                                  (validationTrans.values.items || []).forEach((e, i) => {
                                    if (e.debit > 0) validationTrans.values.items[i].debit = value;
                                    if (e.credit > 0) validationTrans.values.items[i].credit = value;
                                  })
                                  validationTrans.setFieldValue("items", validationTrans.values.items);
                                }}
                              />
                              {validationTrans.touched.amount && validationTrans.errors.amount && (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validationTrans.errors.amount}
                                </p>
                              )}
                            </div>
                            {userType === "admin" && (
                              <div className="mb-3">
                                <CurrencyInput id="paid_amount" name="paid_amount" prefix="Rp. " style={{ border: "1px solid #ccc", width: "100%" }} className="form-control-lg fw-semibold" placeholder="Input Nilai Transaksi" value={validationTrans.values.paid_amount} decimalsLimit={2} onFocus={(e) => e.target.select()} onValueChange={(value, name, values) => validationTrans.setFieldValue("paid_amount", value)} />
                                {validationTrans.touched.paid_amount && validationTrans.errors.paid_amount && (
                                  <p className="invalid-feedback d-block" type="invalid">
                                    {validationTrans.errors.paid_amount}
                                  </p>
                                )}
                              </div>
                            )}
                            <div>
                              <div className="mt-3 d-flex justify-content-between">
                                <Label htmlFor="education" className="form-label">
                                  Bukti Transaksi
                                </Label>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-label btn-soft-success"
                                  onClick={() => {
                                    // setMediaType("other");
                                    toggleMedia();
                                  }}
                                >
                                  <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i>Media
                                </button>
                              </div>
                              {docImg.map((f, i) => {
                                if (f.isDeleted) {
                                  return null;
                                } else {
                                  return (
                                    <div key={i} className="border-bottom mb-3">
                                      <div className="d-flex justify-content-between mb-3 align-items-center">
                                        <div className="me-2">
                                          {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ? (
                                            <ModalImage showRotate={true} small={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt={f.originalname} className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                          ) : (
                                            <Link to={`${api.MEDIA_URL}/media/${f.filename}`} target="_blank" className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                              <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                            </Link>
                                          )}
                                        </div>
                                        <div className="text-truncate">{f.originalname}</div>
                                        <div>
                                          <Link
                                            to="#"
                                            className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                            onClick={(e) => {
                                              handleDeleteFile(f);
                                            }}
                                          >
                                            <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                      {(validationTrans.values.release || []).length ? (
                        <CardBody className="p-3 border-top border-top-dashed position-relative">
                          <div>
                            <h5>Detail Pengajuan Dana</h5>
                            <Table className="invoice-table table-borderless table-nowrap mb-0">
                              <thead className="align-middle">
                                <tr className="table-active">
                                  <th scope="col" style={{ width: "20px" }}>
                                    #
                                  </th>
                                  <th scope="col">Supplier / Kontak</th>
                                  <th scope="col">Type</th>
                                  <th scope="col">RAB</th>
                                  <th scope="col">No Transaksi</th>
                                  <th scope="col">No Invoice</th>
                                  <th scope="col">Jumlah Bayar</th>
                                </tr>
                              </thead>
                              <tbody id="newlink">
                                <tr>
                                  <th></th>
                                  <th colSpan={5}>
                                    Total <em className="fs-11 text-muted fw-normal">jumlah pengajuan harus sama dengan nilai transaksi</em>
                                  </th>
                                  <th className="text-info fs-14">{currencyFormat((info.at_rls || []).reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0))}</th>
                                </tr>
                                {(info.at_rls || [])
                                  .sort((a, b) => a.id - b.id)
                                  .map((o, i) => {
                                    return (
                                      <tr key={i} id={i} className="product">
                                        <th scope="row" className="product-id">
                                          {i + 1}
                                        </th>
                                        <td className="text-start">{o?.at_rls_trx?.at_user?.name || o?.at_rls_vendor?.name}</td>
                                        <td>{o?.type}</td>
                                        <td>{o?.type === "Keuangan" ? o?.at_rls_trx?.at_cvl?.type : o?.type === "SPK" ? o?.at_rls_contract?.cvl_contract_cvl_budget?.type : (o?.at_rls_purchase?.purchase_detail || []).map((m, k) => {
                                          return <div key={k}>{m?.purchase_cvl_budget?.type + ", " + m?.name}</div>
                                        })}</td>
                                        <td>{o?.type === "Keuangan" ? o?.at_rls_trx?.transaction_no : o?.type === "SPK" ? o?.at_rls_contract?.transaction_no : o?.at_rls_purchase?.transaction_no}</td>
                                        <td>{o?.type === "SPK" ? "-" : o?.at_rls_purchase?.transaction_reff}</td>
                                        <td>{currencyFormat(o?.amount)}</td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </Table>
                          </div>
                        </CardBody>
                      ) : null}
                      <CardBody className="p-3 border-top border-top-dashed position-relative">
                        <div>

                          <Table className="invoice-table table-borderless table-nowrap mb-0">
                            <thead className="align-middle">
                              <tr>
                                <td colSpan="2" style={{ width: "40%" }}>
                                  <Select
                                    name="paymentMethod"
                                    value={validationTrans.values.paymentMethod}
                                    placeholder="Jenis Transaksi / Jurnal Otomatis"
                                    onChange={(e) => {
                                      let obj = [
                                        {
                                          itemId: 0,
                                          isPrimary: true,
                                          description: "",
                                          sort_order: 1,
                                          debit: validationTrans.values.amount,
                                          credit: 0,
                                          accId: e?.item?.pm_acc_account?.id ?? "",
                                          acc: e?.item?.pm_acc_account?.id ? { label: e?.item?.pm_acc_account?.code + " - " + e?.item?.pm_acc_account?.name, value: e?.item?.pm_acc_account?.id } : "",
                                        },
                                        {
                                          itemId: 0,
                                          isPrimary: false,
                                          description: "",
                                          sort_order: 2,
                                          debit: 0,
                                          credit: validationTrans.values.amount,
                                          accId: e?.item?.pm_accto_account?.id ?? "",
                                          acc: e?.item?.pm_accto_account?.id ? { label: e?.item?.pm_accto_account?.code + " - " + e?.item?.pm_accto_account?.name, value: e?.item?.pm_accto_account?.id } : "",
                                        },
                                      ];

                                      validationTrans.setFieldValue("items", obj);
                                      validationTrans.setFieldValue("paymentMethod", e);
                                      validationTrans.setFieldValue("tag", e.tag);
                                    }}
                                    options={paymentMethodList}
                                  ></Select>
                                  {validationTrans.touched.paymentMethod && validationTrans.errors.paymentMethod && (
                                    <small className="text-danger" type="invalid">
                                      {validationTrans.errors.paymentMethod}
                                    </small>
                                  )}
                                </td>
                                <td colSpan="3">
                                  <Link
                                    to="#"
                                    className="btn btn-soft-success fw-medium"
                                    id="add-item"
                                    onClick={() => {
                                      handleAccTransDetailAdd();
                                    }}
                                  >
                                    <i className="ri-add-fill me-1 align-bottom"></i>Tambah Akun
                                  </Link>
                                </td>
                              </tr>
                              <tr className="table-active">
                                <th scope="col" style={{ width: "20px" }}>
                                  #
                                </th>
                                <th scope="col">Akun Detail</th>
                                <th scope="col" style={{ width: "120px" }}>
                                  Debit
                                </th>
                                <th scope="col" style={{ width: "120px" }}>
                                  Credit
                                </th>
                                <th scope="col" style={{ width: "200px" }}>
                                  Keterangan
                                </th>
                                <th scope="col" className="text-end" style={{ width: "35px" }}></th>
                              </tr>
                            </thead>
                            <tbody id="newlink">
                              {(validationTrans.values.items || []).map((o, i) => {
                                return (
                                  <tr key={i} id={i} className="product">
                                    <th scope="row" className="product-id">
                                      {i + 1}
                                    </th>
                                    <td className="text-start">
                                      <Select
                                        name="item"
                                        value={validationTrans.values.items[i].acc ?? ""}
                                        placeholder="Pilih Akun"
                                        onChange={(e) => {
                                          validationTrans.values.items[i].acc = e;
                                          validationTrans.values.items[i].accId = e.value;
                                          validationTrans.values.items[i].sort_order = i;
                                          validationTrans.setFieldValue("items", validationTrans.values.items);
                                        }}
                                        options={accountingList}
                                        validate={{ required: { value: true } }}
                                      ></Select>
                                    </td>
                                    <td>
                                      <div>
                                        <CurrencyInput
                                          prefix="Rp. "
                                          style={{ border: "1px solid #ccc", width: "180px" }}
                                          className="form-control product-price"
                                          placeholder="Isi Debit"
                                          value={validationTrans.values.items[i].debit}
                                          decimalsLimit={2}
                                          onFocus={(e) => e.target.select()}
                                          onValueChange={(value, name, values) => {
                                            validationTrans.values.items[i].debit = parseFloat(value);
                                            validationTrans.setFieldValue("items", validationTrans.values.items);
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div>
                                        <CurrencyInput
                                          prefix="Rp. "
                                          style={{ border: "1px solid #ccc", width: "180px" }}
                                          className="form-control product-price"
                                          placeholder="Isi Credit"
                                          value={validationTrans.values.items[i].credit}
                                          decimalsLimit={2}
                                          onFocus={(e) => e.target.select()}
                                          onValueChange={(value, name, values) => {
                                            validationTrans.values.items[i].credit = parseFloat(value);
                                            validationTrans.setFieldValue("items", validationTrans.values.items);
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <Input
                                        name="description"
                                        style={{ width: "280px" }}
                                        type="text"
                                        className="form-control"
                                        value={validationTrans.values.items[i].description}
                                        onChange={(e) => {
                                          validationTrans.values.items[i].description = e.target.value;
                                          validationTrans.setFieldValue("items", validationTrans.values.items);
                                        }}
                                        onBlur={validationTrans.handleBlur}
                                      />
                                    </td>
                                    <td>
                                      <Link
                                        to="#"
                                        className="text-danger btn-icon btn btn-soft-danger flex-shrink-0"
                                        onClick={() => {
                                          onClickDeleteDetailItem(i);
                                        }}
                                      >
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })}

                            </tbody>
                          </Table>
                        </div>
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="button" className="btn btn-light" onClick={toggleTrans}>
                          TUTUP
                        </button>

                        <button type="submit" className={"btn btn-primary"} disabled={loading}>
                          <span className="d-flex align-items-center">
                            {isEditTrans ? "EDIT TRANSAKSI" : "SIMPAN JURNAL UMUM"}
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
                {/* /// */}
              </CardBody>
            </Card>
          </Col>
        </Row>
        <PrintDoc innerRef={printRef} item={accAccountList} />
      </Container>
    </div>
  );
};

export default AccTrans;
